// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__39VMj","col":"styles_col__3lmGp"};